<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          v-if="userisadmin"
          class="color"
          cols="12"
          lg="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-chart-areaspline"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Estate Summary
              </div>
              <div class="display-2 font-weight-light">
                Active Units {{ totalunits }} Total Cash Present {{ cashonhand }}
              </div>
            </template>
            <apexchart
              type="bar"
              height="320"
              :options="chartOptions"
              :series="sum_data"
            />
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
    <sequential-entrance from-left>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="6"
        >
          <base-material-card
            inline
            class="col-md-12"
            color="orange"
            title="Status Info"
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Smart Safe Estate Status
              </div>
            </template>

            <v-divider class="mt-3" />

            <v-data-table
              :headers="locationHeaders"
              :items="getlocs"
              :search="sitesearch"
              :items-per-page="5"
              sort-by="heartbeat.timestamp"
              sort-desc
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Status Information</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="sitesearch"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                </v-toolbar>
              </template>
              <template v-slot:item.contact="{ item }">
                {{ format_time(item.contact) }}
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn
                  small
                  class="mr-2"
                  color="primary"
                  :to="'/safes/' + item.id"
                  @click="request_transactions(item.id)"
                >
                  View
                </v-btn>
              </template>
              <template v-slot:no-data>
                No Data to display
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>

        <v-col
          cols="12"
          sm="12"
          lg="6"
        >
          <base-material-card
            color="transparent"
            image
            hover-reveal
          >
            <template v-slot:image>
              <v-img
                src="/img/cash3.jpg"
                height="150"
              />
            </template>

            <template v-slot:reveal-actions>
              <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn

                    class="mx-1"
                    v-bind="attrs"
                    to="/Reports"
                    v-on="on"
                  >
                    <v-icon>mdi-view-split-vertical</v-icon>Report Actions
                  </v-btn>
                </template>
                <span>View</span>
              </v-tooltip>
            </template>

            <v-card-title class="justify-center font-weight-light">
              Estate Reports
            </v-card-title>

            <v-card-text class="body-1 text-center mb-3 font-weight-light grey--text">
              Site reports: Live Balance, Deposits, Cash In Transit, End of Day
            </v-card-text>

            <template v-slot:actions>
              <div class="display-2 font-weight-light grey--text" />

              <v-spacer />

              <span class="caption grey--text font-weight-light" />
            </template>
          </base-material-card>
          <base-material-card
            color="transparent"
            image
            hover-reveal
          >
            <template v-slot:image>
              <v-img
                src="/img/vault2.jpg"
                height="150"
              />
            </template>

            <template v-slot:reveal-actions>
              <v-tooltip bottom>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn

                    class="mx-1"
                    v-bind="attrs"
                    to="/ReportsDevices"
                    v-on="on"
                  >
                    <v-icon>mdi-view-split-vertical</v-icon>Device Actions
                  </v-btn>
                </template>
                <span>View</span>
              </v-tooltip>
            </template>

            <v-card-title class="justify-center font-weight-light">
              Device Reports
            </v-card-title>

            <v-card-text class="body-1 text-center mb-3 font-weight-light grey--text">
              Site reports: Note Reader Activity, Device Status
            </v-card-text>

            <template v-slot:actions>
              <div class="display-2 font-weight-light grey--text" />

              <v-spacer />

              <span class="caption grey--text font-weight-light" />
            </template>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { nanoid } from 'nanoid'

  var numeral = require('numeral')

  export default {
    name: 'Dashboard',

    data () {
      return {
        icons: true,
        loading: false,
        centered: true,
        newtab: null,
        activeBtn: 1,
        sitesearch: '',
        grow: true,
        tab: null,
        totalunits: '',
        cashonhand: '',
        sums: [],
        graphsums: [],
        graphdays: [],
        locationHeaders: [
          {
            sortable: false,
            text: 'Site',
            value: 'idnum'
          },
          {
            sortable: false,
            text: 'Ver',
            value: 'version'
          },
          {
            sortable: false,
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Rej.',
            value: 'rejcount',
            align: 'center'
          },
          {
            sortable: true,
            text: 'Comms',
            value: 'lastcoms',
            align: 'center'
          },
          {
            sortable: false,
            text: 'Span',
            value: 'ago',
            align: 'center'
          }
        ],

        chartOptions: {
          chart: {
            height: 350,
            toolbar: false,
          },

          plotOptions: {
            bar: {
              columnWidth: '50%',
            },
          },

          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#3bd6c6'],
              shadeIntensity: 1,
              opacityFrom: 0.9,
              opacityTo: 0.9,
              stops: [0, 90, 100]
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          title: {
            text: '',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return numeral(value).format('$0,0.00')
              }
            }
          },
          xaxis: {
            categories: [],
            labels: {
              formatter: function (value) {
                return moment(value).format('YYYY-MM-DD: HH:mm')
              }
            }
          }
        },
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false
        }
      }
    },
    computed: {
      userisadmin () {
        if (
          this.$store.getters.user.status === 'admin' &&
          this.loading === false
        ) {
          return true
        }
        return false
      },
      currentsafes () {
        let sfs = this.$store.getters.safesstatus
        sfs = this.$store.getters.safesstatus.filter(function (safe) {
          return safe.ssname !== 'Not Listed'
        })
        this.totalunits = sfs.length

        this.$log.debug('SAFES ARE ', sfs)
        return sfs
      },
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          // console.log('our loaded dash sites ', this.$store.getters.loadedSites)
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            name = loc.sitename
          }
          if (value.siteunitsprofile) {
            let version = '*'
            let lastcoms = 'NA'
            let ago = '*'
            let servertime = 'NA'
            let status = 'NA'
            let rejcount = 0
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            this.$log.debug('looking for events for safe ', safeid)
            if (!safeid) {
              console.log('NO SAFE ID ', value)
              return
            }
            if (safeid.includes('Virtual')) {
              status = '-'
              version = 'Virtual'
            }
            if (safeid.includes('Postal')) {
              status = '-'
              version = 'Postal'
            }
            let events = eventlist.filter(event => event.crypto_idnum === safeid)
            if (events.length > 0) {
              let todaysevents = events.filter(event => event.day === today)
              if (todaysevents.length > 0) {
                this.$log.debug('today is ', today, ' Todays events ', todaysevents)
                rejcount = todaysevents[0].rejcount
                // this.$log.debug('count is ', todaysevents[0].rejcount)
              }
              //
            }

            let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
            if (rec && rec.heartbeat && rec.servertime) {
              lastcoms = moment(rec.heartbeat).format('YYYY-MM-DD HH:mm')
              ago = moment(rec.heartbeat).fromNow('HH:mm:ss')
              servertime = moment(rec.servertime).format('YYYY-MM-DD HH:mm')
            }
            if (rec && rec.version) {
              version = rec.version
            }

            if (rec) {
              let now = Date.now()
              let mContact = moment(rec.heartbeat)
              let mNow = moment(now)
              let duration = moment.duration(mNow.diff(mContact))
              this.$log.debug('minutes since last contact', duration.asMinutes())
              let MINUTES_CONSIDERED_OFFLINE = 60

              // this.lastheartbeat = moment(rec.heartbeat)
              // this.$log.debug('last heartbeat ', this.lastheartbeat)
              if (duration.asMinutes() <= MINUTES_CONSIDERED_OFFLINE) {
                status = 'Online'
              }
              if (duration.asMinutes() >= MINUTES_CONSIDERED_OFFLINE) { // 60  minutes
                status = 'Offline'
              }
            }
            let shop = {
              idnum: key,
              safeid: safeid,
              status: status,
              rejcount: rejcount,
              sitename: name,
              version: version,
              lastcoms: lastcoms,
              servertime: servertime,
              ago: ago
            }
            this.locations.push(shop)
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      },

      sum_data () {
        this.sums = Object.values(this.$store.getters.estatesums)
        // we dont have days we have locations
        this.graphdays = [...this.sums.map(data => data.timestamp)]

        // sum is the cash on hand for each ie cash held
        this.graphsums = [...this.sums.map(data => data.sum)]

        this.chartOptions.xaxis.categories = this.graphdays.reverse()

        this.cashonhand = this.graphsums[this.graphsums.length]

        this.cashonhand = numeral(this.graphsums[0]).format('$0.00')
        return [
          { name: 'Estate Cash Amounts', data: [...this.graphsums.reverse()] }
        ]
      },
      currentLocations () {
        return this.$store.getters.loadedSites
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.sum, 0)
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 3000)
      }
    },
    timers: {
      log: { time: 900000, autostart: true, repeat: true }
    },
    created () {
      this.loading = true
      let postalid = 'PostalSafe-' + nanoid()
      console.log('postal id ', postalid)
      this.$store.dispatch('loadCurrentUserProfile')
      this.$store.dispatch('loadEstateSums')
      this.$store.dispatch('loadsplit')
      this.sums = Object.values(this.$store.getters.estatesums)
      this.$store.dispatch('loadnotereaderevents')
      this.$store.dispatch('loadccSites')
      // this.$store.dispatch('loadChangeOrders')
    },
    beforeDestroy () {
    // this.$store.dispatch('resetsafetransactions')
    },
    methods: {
      log () {
      // this.$store.dispatch('loadEstateSums')
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('MM-DD-YY, HH:mm:ss')
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
